export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  ACCOUNT: { CREATE: "/accounts/e", LIST: "/accounts", EDIT: "/accounts/:id/e", VIEW: "/accounts/:id" },
  CONTACT: { CREATE: "/contacts/e", LIST: "/contacts", EDIT: "/contacts/:id/e", VIEW: "/contacts/:id" },
  USER: { CREATE: "/users/e", LIST: "/users", EDIT: "/users/:id/e", VIEW: "/users/:id" },
  PRODUCT:{ CREATE: "/products/e", LIST: "/products", EDIT: "/products/:id/e", VIEW: "/products/:id" },
  PURCHASE_ORDER:{ CREATE: "/purchase-orders/e", LIST: "/purchase-orders", EDIT: "/purchase-orders/:id/e", VIEW: "/purchase-orders/:id" },
  SERVICE_ORDER:{ CREATE: "/service-orders/e", LIST: "/service-orders", EDIT: "/service-orders/:id/e", VIEW: "/service-orders/:id" },
  FINANCIAL_YEAR:{ CREATE: "/financialyears/e", LIST: "/financialyears", EDIT: "/financialyears/:id/e", VIEW: "/financialyears/:id" },
  BRANCH:{ CREATE: "/branches/e", LIST: "/branches", EDIT: "/branches/:id/e", VIEW: "/branches/:id" },
  SUB_CATEGORY:{ CREATE: "/subcategories/e", LIST: "/subcategories", EDIT: "/subcategories/:id/e", VIEW: "/subcategories/:id" },
  CATEGORY:{ CREATE: "/categories/e", LIST: "/categories", EDIT: "/categories/:id/e", VIEW: "/categories/:id" },
  INVENTORY:'/inventory',
  REPORT: { CREATE: "/reports/e", LIST: "/reports", EDIT: "/reports/:id/e", VIEW: "/reports/:id" },
  DASHBOARD: "/dashboards",
  BACKUP: "/backups",
  PROFILE:"/profile",
}